import React from 'react'
import { Field } from 'react-final-form'
import { TextField } from 'elentari'

const Usuario = props => {
  return (
    <Field
      name="usuario"
      label="Usuário"
      fullWidth
      component={TextField}
      {...props}
    />
  )
}
export default Usuario
